import { INTERNAL_EVT_SESSION_DEADLINE as y } from "./constants.js";
import { createAbortable as A } from "../../../async/abortable/main.js";
import { createEventEmitter as g } from "../../../reactive/eventEmitter/main.js";
import { createPromisor as S } from "../../../async/promisor/main.js";
import { parseDate as D } from "../../../../utils/datetime/main.js";
import { isAbortSignal as I, abortSignalForAny as N, abortedSignal as v } from "../../../../utils/abort/main.js";
import { clock as w } from "../../../time/clock/main.js";
import { isWatchlistUnsubscribeToken as F } from "../../../reactive/watchlist/main.js";
import { tryResolve as L } from "../../../../utils/async/main.js";
import { noop as T } from "../../../../utils/common.js";
import { struct as k } from "../../../../utils/struct/main.js";
import { enumerable as c, getter as _ } from "../../../../utils/struct/property.js";
import { isFunction as P } from "../../../../utils/value/is.js";
const O = (R, b) => {
  let r, i = 1 / 0, p, o;
  const n = A(), u = g(), m = () => {
    r == null || r.removeEventListener("abort", m), i = 1 / 0, o == null || o(), n.refresh(), u.emit(y);
  }, E = S(async (t, a) => {
    p = t;
    const f = await L(() => {
      const e = b.deadline;
      return P(e) ? e.call(b, a, t) : e;
    }).catch(T);
    if (p !== t) return;
    const d = (Array.isArray(f) ? f : [f]).filter((e) => e || e === 0);
    if (d.length > 0) {
      let e = !1, s = /* @__PURE__ */ new Set();
      for (const l of d)
        if (I(l)) {
          if (e = l.aborted) break;
          s.add(l);
        } else if (i = Math.min(i, D(l) ?? 1 / 0), e = i <= Date.now()) break;
      e || (e = s.size < 1 && !Number.isFinite(i)), e ? r ?? (r = v()) : (r = N([...s, n.signal]), r.addEventListener("abort", m), h()), d.length = 0, s.clear();
    } else r = void 0;
  }), h = () => {
    if (!Number.isFinite(i)) return;
    let t = w.subscribe((a) => {
      if (F(a)) return m();
      a.now >= i && n.abort();
    });
    o = () => {
      t == null || t(), t = o = void 0;
    };
  };
  return k({
    elapse: c(n.abort),
    elapsed: _(() => r && r.aborted),
    on: c(u.on),
    refresh: c(E.bind(void 0)),
    signal: _(() => n.signal)
  });
};
export {
  O as createSessionDeadline,
  O as default
};
